module.exports = __webpack_public_path__ + "media/images/guide/image4-0d31a4d2dad57124543b2934be4c9a57.png";